import { DOMAttributes, HTMLAttributes } from "react";

type Props = DOMAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & {
  value: string;
}

const Html = ({ value, ...props }: Props) => {
  return (
    <div
      dangerouslySetInnerHTML={ { __html: value } }
      { ...props }
    />
  )
}

export default Html;
